@use '@lib/assets/styles/main.scss' as *;

.backBtnWrap {
  margin-bottom: 24px;
}
